export default __webpack_public_path__ + "static/media/architecture-5999913_640.a08c5bb7.jpg";